import { MatDialogRef, MatSelectChange, MatSnackBar } from '@angular/material';
import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ApiProvider } from '../../../@core/providers/api.provider';
import { GeoTabUser } from '../../../@core/models/geoab-user';
import { StopService } from '../../../@core/services/stop.service';
import { SectorService } from '../../../@core/services/sector.service';
import { AuthenticationService } from '../../../@core/services/authentication.service';
import { GeoTabUserAssign } from '../../../@core/models/geoab-user-assign';


type RouteAssignUser = {
  routeId?      : number;
  geoTabUserId? : string;
  searchQuery?: string; // Recherche spécifique
  filteredUsers?: GeoTabUser[]; 
};

@Component({
  selector: 'select-geotab-user',
  templateUrl: './select-geotab-user.component.html',
  styleUrls: ['./select-geotab-user.component.scss']
})
export class SelectGeotabUser implements OnInit {

  @ViewChildren('searchInputs') searchInputss!: QueryList<ElementRef>;

  public searchQuery      = '';
  geotabusers             : Array<GeoTabUser>;
  public selectedgeotabId : string;
  filteredGeotabUsers     : GeoTabUser[];
  usersAssignRoute        : RouteAssignUser [] = [];
  isLoading               : boolean = false; 

  constructor(
    public dialogRef            : MatDialogRef<SelectGeotabUser>,
    private apiPorvider         : ApiProvider,
    private readonly sectorServ : SectorService,
    private readonly stopServ   : StopService,
    private authenticationService: AuthenticationService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.apiPorvider.getGeoTabUsers().subscribe(
      (result) => {
        
        this.geotabusers = result;

        this.geotabusers.sort((a,b) => a.Firstname.localeCompare(b.Firstname));

        this.filteredGeotabUsers = [...this.geotabusers];
        
        this.apiPorvider.getGeoTabUserAssignBySector(this.sectorServ.SectorID).subscribe(
          (usersAssign) => {

            let usersAssignByRoute  = this.filterByLatestAssignDate(usersAssign);

            for(let routeCompress of this.sectorServ.currentSectorValue.RouteCompress){
              
              let routeAssignUser: RouteAssignUser = {
                geoTabUserId: '',
                searchQuery: '',
                filteredUsers: [...this.geotabusers], // Liste filtrée initialisée avec tous les utilisateurs
              };
  
              routeAssignUser.routeId = routeCompress.Route_ID;
              let userAssignToRoute = usersAssignByRoute.find(u => u.routeId == routeCompress.Route_ID);
  
              if (userAssignToRoute) {
                routeAssignUser.geoTabUserId = userAssignToRoute.GeoTabUserId;
              }
  
              this.usersAssignRoute.push(routeAssignUser);
              
              this.isLoading = false;
            }
          },
          (err) => {
            this.isLoading = false;
          }
        )
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  filterByLatestAssignDate(users: GeoTabUserAssign[]): GeoTabUserAssign[] {
    const routeIdMap = new Map<string, GeoTabUserAssign>();
  
    for (const user of users) {
      const existingUser = routeIdMap.get(user.routeId.toString());
  
      if (!existingUser || new Date(user.AssignDate) > new Date(existingUser.AssignDate)) {
        routeIdMap.set(user.routeId.toString(), user);
      }
    }
  
    return Array.from(routeIdMap.values());
  }

  public goBack(): void {
    this.dialogRef.close(false);
  }

  filterGeotabUsers(route: RouteAssignUser) {

    const query = route.searchQuery.toLowerCase() || '';
  
    // Filtrer les utilisateurs pour cet élément spécifique
    let filtered = this.geotabusers.filter(
      user =>
        user.Firstname.toLowerCase().includes(query) ||
        user.Lastname.toLowerCase().includes(query)
    );
  
    // Ajouter l'utilisateur sélectionné s'il n'est pas déjà dans la liste filtrée
    const selectedUser = this.geotabusers.find(user => user.GeoTabUserId === route.geoTabUserId);
    if (selectedUser && !filtered.some(user => user.GeoTabUserId === selectedUser.GeoTabUserId)) {
      filtered = [selectedUser, ...filtered];
    }
  
    route.filteredUsers = filtered;
  }

  focusSearchInput(isOpen: boolean, routeId : number, index : number) {
    const inputElement = this.searchInputss.toArray()[index];
    
    if (inputElement) {
      setTimeout(() => inputElement.nativeElement.focus(), 0);
    }
  }

  onSelectionChange(event: MatSelectChange, userAssignRoute : RouteAssignUser): void {

    let selectedgeotabId = event.value;

    let email : string;

    for(let geoTabUser of this.geotabusers){
      if(geoTabUser.GeoTabUserId == selectedgeotabId){
        email = geoTabUser.Email;
        break;
      }
    }
    if(email){

      this.apiPorvider.setGeoTabUser(selectedgeotabId, userAssignRoute.routeId, email , this.authenticationService.currentUserValue.UserID ).subscribe(
        (result) => {
          this._snackBar.open('Chauffeur assigné avec succès', "", { duration: 5000, panelClass : ['backgroundcolorgreen']  });
        },
        (error) => {
          this.ngOnInit();
          this._snackBar.open('Erreur lors de l\'assignation du chauffeur', "", { duration: 5000, panelClass : ['backgroundcolor'] });
        }
      )
    }else{
      console.error("Cette user n'a pas de courriel ! Veuillez contacter un agent Nationex")
    }

  }

}
